/* eslint-disable @typescript-eslint/naming-convention */
export enum timeUnitsEnum {
    seconds,
    minutes,
    hours
}
